'use strict';
(function () {
  var _controller = 'turns.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', '$interval', '$q', 'reservation.resource', 'router.resource', 'flyer.resource', '$timeout', 'hq.socket', 'reservationStats.resource', 'bottomLogin.modal', 'appRate.modal'];
  function controller($scope, $interval, $q, turnResource, routerResource, flyerResource, $timeout, hqSocket, reservationStats, loginModal, appRateModal) {

    /// METHODS
    $scope.newTurn = newTurn;
    $scope.goTo = goTo;
    $scope.cancelTurn = cancelTurn;
    $scope.turnTracking = turnTracking;
    $scope.openChat = openChat;
    $scope.refresh = refresh;
    $scope.openLoginModal = openLoginModal;
    $scope.objTypeArr = objTypeArr;
    var debouncedRefresh = debounce(refresh, 1000)
    var debouncedRouter = debounce(refreshRouter, 500)

    /// VARS
    $scope.cIndex = 0;
    $scope.utcOffset = new Date().getTimezoneOffset()
    $scope.utcOffset = ($scope.utcOffset > 0 ? '-' : '') + padStart(Math.floor($scope.utcOffset / 60)) + padStart($scope.utcOffset % 60)
    var myself = appNavigator.topPage.myself = new Object();
    $scope.currentRouter = null;
    $scope.turns = [];
    $scope.stats = null;
    $scope.routerStats = null;
    $scope.routers = routerResource.query({ _controller: _controller });
    $scope.flyerResource = flyerResource;
    $scope.turnCarousel = null;
    var compatibilityAlertShown = false;
    var interval = null;
    var event = window.queryStrings.event;
    var turn = window.queryStrings.turn;

    // WATCHERS
    $scope.$on('$destroy', onDestroy)
    $scope.$on('login', refresh);
    $scope.$on('defaultRouter', debouncedRouter);
    hqSocket.on('reconnect', onReconnect);
    hqSocket.on('RESERVATION-UPSERT', reservationUpsert);

    /// INIT
    interval = $interval(reservationStatistics, 3000);
    if (!profile._id) openLoginModal()
    debouncedRouter();
    refreshFlyers();
    if (profile.enterprise.pwaConfig && profile.enterprise.pwaConfig.menuItems && profile.enterprise.pwaConfig.menuItems.enableChat === 'CHAT-VIDEO')
      checkCompatibility();

    /////////////////////
    function padStart(str) { return ('0' + str).substr(-2) }

    function onReconnect() {
      debouncedRouter();
      refreshFlyers();
    }

    function refreshRouter() {
      var currentRouter = $scope.$root.defaultRouter;
      routerResource.get({ _id: currentRouter, _controller: _controller }, function (result) {
        $scope.currentRouter = result;
        if ($scope.currentRouter && event) $timeout(function () { newTurn() }, 500);
        if ($scope.currentRouter && turn) $timeout(function () { newTurn() }, 500);
        refreshFlyers();
        refresh();
      });
    }

    function refresh(ignoreVeil) {
      if (!$scope.currentRouter) return console.error('ERR_NO_HAY_CURRENT_ROUTER')
      if (!$scope.$root.profile._id) return
      var turns = turnResource.query({ myReservations: true, _controller: _controller, ignoreVeil: ignoreVeil })
      var stats = reservationStats.get({ router: $scope.currentRouter._id, _controller: _controller, ignoreVeil: ignoreVeil })

      $q
        .all([turns.$promise, stats.$promise])
        .then(function () {
          // Si había turnos y ahora no hay es porque terminó el turno, ya que cancelar lo borra de la lista sin hacer refresh
          if ($scope.turns && $scope.turns.length && turns && !turns.length) appRateModal.open('turnClosed')
          $scope.turns = turns;
          $scope.stats = stats;
          if (turns.length) {
            $timeout(function () {
              if (profile._id && profile.enterprise && profile.enterprise.pwaConfig &&
                profile.enterprise.pwaConfig.menuItems && profile.enterprise.pwaConfig.menuItems.enableChat === 'CHAT-VIDEO') {
                if (!checkCompatibility()) return;
                chatUtils.availableMediaDevices(i18next.t('Para hacer uso de la atención remota necesitamos acceso a tus dispositivos multimedia'), function () { })
              }
            }, 1000)
            if (myself === appNavigator.topPage.myself) autoOpenChat();
          }
        })
        .catch(function (err) { if (err) throw new PentaError(err) })
    }

    function reservationStatistics() {
      if (!$scope.turns || !$scope.turns.length) return // si no hay turnos return.
      var currentTurn = $scope.turns[0]; //- asigna el primer turno de la lista.
      if (currentTurn.queueStatus === "ATTENDING") return //- si el turno esta atendido no obtengo estadisticas.
      currentTurn.date = new Date(currentTurn.date);
      var turnDate = currentTurn.date - Date.now(); //- Diferencia entre la hora del turno y la hora actual.
      var oneHour = 3600000; //- equivalente en milisegundos de una hora.
      if (turnDate > oneHour) return //- el turno no esta dentro del rango de estadisticas ( 1 hora previa ).
      if ($scope.stats) avgReservationStats(currentTurn);
    }

    function avgReservationStats(currentTurn) {
      var reservationDelay = -5; //- Demora, luego de llegar a la hora de la reserva, para dar aviso de la demora. (numero negativo).
      var leftMinutes = ((Date.now() - currentTurn.date) / 1000 / 60) //- minutos que pasaron desde la reserva hasta ahora.
      var avgWaiting = $scope.stats.avgWaiting - leftMinutes; //- minutos que hay entre lo ya esperado y el tiempo de espera promedio.
      if (!currentTurn._stats) currentTurn._stats = { client: null, avgWaiting: null }
      currentTurn._stats.clients = $scope.stats.clients;
      currentTurn._stats.avgWaiting = avgWaiting;
      if (avgWaiting && Number(avgWaiting.toFixed(1)) <= reservationDelay) {
        if (appStorage.get('reservationAlertShownId') === currentTurn._id) return
        appStorage.set('reservationAlertShownId', currentTurn._id);
        ons.notification.alert({ title: i18next.t("Disculpe la demora"), message: i18next.t('En breve será atendido, manténgase atento a la APP') });
      }
    }

    function newTurn() {
      if (!$scope.currentRouter) return;
      appNavigator.pushPage('turns/newTurn/newTurn.jade', { data: { onClose: reservationUpsert, currentRouter: $scope.currentRouter } });
    }

    /// Se usaba en mediaturno antes, ya no se usa
    function turnTracking(turn) {
      var parts = turn.extraData.externalId.split('-');
      var empresa = parts[0];
      var sucursal = parts[1];

      var turnRouter = $scope.routers.find(function (router) { return router._id == turn.router });

      var queryStringParams = {
        idEmpresa: empresa,
        idSucursal: sucursal,
        description: turnRouter.name,
        letter: turn.extraData.letter,
        place: turn.extraData.place,
        production: turn.extraData.production
      }

      appNavigator.pushPage('turns/turnTracking/turnTracking.jade', { data: { onClose: refresh, currentRouter: $scope.currentRouter, params: queryStringParams } });
    }

    function cancelTurn(turn, index, message) {
      ons.notification.confirm({ message: message, title: 'Confirmación', buttonLabels: ['No', 'Si'] })
        .then(function (confirm) {
          if (confirm) {
            turnResource.cancelReservation({ _id: turn._id, _controller: _controller }, function () {
              // Si se cambia este splice por un refresh notar que en refresh va a ejecutar appRateModal.open
              // esto va a hacer que se pida un comentario de la app al momento en que se cancela un turno
              $scope.turns.splice(index, 1);
            })
          }
        })
    }

    function onDestroy() {
      $scope.$root.abortRequests(_controller);
      hqSocket.removeListener('RESERVATION-UPSERT', reservationUpsert);
      hqSocket.removeListener('reconnect', onReconnect);
      $interval.cancel(interval);
    }

    function goTo(url) {
      var win = window.open(url, '_blank');
      win.focus();
    }

    function reservationUpsert() { debouncedRefresh(true) }

    function refreshFlyers() {
      flyerResource.query({ _controller: _controller, destination: ['APP-TURN'] }, function (flyers) {
        $scope.turnCarousel = window.flyerFilter(flyers, $scope.$root.defaultRouter);
        $scope.$root.carouselAutoscroll($scope, $scope.carousel, $scope.turnCarousel)
      })
    }

    function autoOpenChat() {
      if ($scope.$root.chatOpened) return
      if (!$scope.turns || !$scope.turns.length) return
      //if ($scope.turns.length > 1) return //Abre el chat siempre, o es confuso porque no se sabe que te estan hablando //- Solamente se abre el chat automaticamente cuando hay una sola reserva.
      var turn = $scope.turns.find(function (f) { return f.chat && f.chat.clientBadge >= 1 })
      if (turn) openChat(turn, true)
    }

    function openChat(turn, forced) {
      if (forced || (turn.queueStatus && turn.queueStatus === "ATTENDING")) return appNavigator.pushPage('chat/chat.jade', { data: { title: 'Turno ' + turn.serial, relatedObject: turn._id, relatedObjectType: 'reservation', user: turn.queueUser } })
      var message = i18next.t('Los mensajes serán respondidos cuando llegue su turno') + '. <br><br>' + i18next.t('Muchas Gracias')
      ons.notification.confirm({
        message: message,
        title: i18next.t('Aviso'),
        buttonLabels: [i18next.t('Cerrar'), i18next.t('Abrir Chat')]
      })
        .then(function (confirm) {
          var title = profile.enterprise.pwaConfig.turnsConfig && profile.enterprise.pwaConfig.turnsConfig.turnSingularAs || i18next.t('turno');
          if (confirm) appNavigator.pushPage('chat/chat.jade', { data: { title: title + ' ' + turn.serial, relatedObject: turn._id, relatedObjectType: 'reservation' } })
        })
    }

    function checkCompatibility() {
      var result = $scope.$root.checkVideoconferenceCompatibility();
      if (result.alert.show) showAlertDebounced(result.alert);
      return result.compatibility;
    }

    // alert={
    //   title: i18next.t('text'),
    //   message: i18next.t('text'),
    // }
    function showAlertDebounced(alert) {
      if (compatibilityAlertShown) return
      compatibilityAlertShown = true;
      $timeout(function () { compatibilityAlertShown = false }, 10000);
      ons.notification.alert({
        title: alert.title,
        message: alert.message,
      })
    }

    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    function openLoginModal() {
      loginModal.open({ title: i18next.t('Debes iniciar sesión') })
    }

    function objTypeArr(obj) {
      if (!obj) return false
      if (angular.isArray(obj)) return true
      return false
    }
    //// FIN CONTROLLER
  }
})();
